import type { LucideIcon } from 'lucide-react';

interface BotaoFlutuanteProps {
  icon: LucideIcon;
  label: string;
  onClick: () => void;
}

// Ação principal da tela no app (celular): botão redondo acima da barra
// inferior. No desktop não aparece; a tela mantém o botão do cabeçalho, que
// some no celular com `max-md:hidden`.
export function BotaoFlutuante({ icon: Icon, label, onClick }: BotaoFlutuanteProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      title={label}
      className="fixed right-4 z-20 flex size-14 items-center justify-center rounded-2xl bg-primary text-bg-main shadow-elevated transition-transform active:scale-95 md:hidden"
      style={{ bottom: 'calc(var(--app-bottom, 0px) + 1rem)' }}
    >
      <Icon size={24} />
    </button>
  );
}
